export interface AllStoreSettings {
  stores: StoreSettings[];
}

export enum StoreRetailerFlagsWithLabel {
  IS_HUB_CUSTOMER = 'Hub customer',
  DISABLED_SENDER_RECEIPTS = 'Disable sender receipts',
  PERFORMS_PRESORTING = 'Partner performs presort',
  ALLOW_RECIPIENT_REBOOKING = 'Allow recipient rebooking',
  SUPPORTS_WIDE_BARCODE_LABELS = 'Wide barcode enabled',
  DELAYED_ORDER_CREATION_RECEIPTS = 'Order receipt creation delay',
  VALIDATED_PARCEL_INFORMATION = 'Parcel information validated',
  SUPPORTS_COMPLETE_SCAN = 'Complete scan supported',
  PRINT_SHOPIFY_ORDER_NUMBER = 'Print Shopify order number on labels',
  PRINT_SMALL_LABELS = 'Print small labels as default',
  CAN_DO_IDENTITY_CHECK = 'Can do identity check',
  CAN_DO_AGE_VERIFICATION = 'Can do age verification',
  PERFORMS_IBX_PREBOOKINGS = 'Performs prebooking (IBX HD)',
}

export enum StoreCapacityFlagsWithLabel {
  SUPPORTS_CAPACITY_ORDERING = 'Order 2h windows by usage',
  ENABLE_TWO_HOUR_WINDOW_CAPACITY_MANAGEMENT = '2 hour window capacity management',
}

export type DuplicateDetection =
  | 'NONE'
  | 'ORDER_REFERENCE'
  | 'CONSIGNOR_DUPLICATES';

export type WindowTypes = 'REGULAR' | 'DYNAMIC' | 'SINGLE_LONG';

export type ConsolidationSupport = 'NONE' | 'ANONYMOUS' | 'KNOWN_RECIPIENT';

export interface StoreSettings {
  name: string;
  accountId: number;
  enabled: boolean;
  dailyCutOffTime: string;
  packagingCutoff: string;
  qbbCutoffAdjustmentMinutes: string;
  displayBasePriceCents: string | null;
  discountThresholds: ValueBasedDiscount[];
  temperatureControlPriceAdjustment: string;
  duplicateDetection: DuplicateDetection;
  shopHomePage?: string;
  consolidationSupport: ConsolidationSupport;
  deliveryRegions: string[];
  windowTypes: WindowTypes[];
  flags: string[];
}

export interface ValueBasedDiscount {
  threshold: string;
  discount: string;
}
